import React from "react";
import { Card, CardBody, Col, Row, Spinner } from "reactstrap";
import notFound from "../../assets/imgs/not-found.png";
import { PurchaseOrderDetailsHeader } from "../../components/Headers/Headers";
import GeneralButton from "../../components/button/GeneralButton";
import NotesCard from "../../components/cards/NotesCard";
import AddOrderItem from "../../components/modals/AddOrderItem";
import PageName from "../../components/react_helmet/PageName";
import InternalNotesTable from "../../components/table/InternalNotesTable";
import useCreatePurchaseOrder from "./customHooks/useCreatePurchaseOrder";
import PurchaseItemCard from "../../components/cards/PurchaseItemCard";
import PurchaseTotalCard from "../../components/cards/PurchaseTotalCard";
import OrderBillingAddressCard from "../../components/cards/OrderBillingAddressCard";
import OrderShippingAddressCard from "../../components/cards/OrderShippingAddressCard";
import PurchaseOrderInformations from "../../components/cards/PurchaseOrderInformations";
import POBasicInformations from "../../components/cards/POBasicInformations";
import { FiFileText } from "react-icons/fi";
import moment from "moment";
import OrderDetailsSkeleton from "../../components/skeleton/OrderDetailsSkeleton";
const BLIND_SHIPPING_DIRECTIVE = `************BLIND SHIPPING ONLY************\nPlease do NOT include any pricing on invoices, receipts, price tags, or promotional materials inside or outside the package`;

const isBlindShippingNotePresent = (text) => {
  if (!text) return false;
  return /\*+\s*BLIND SHIPPING ONLY\s*\*+/i.test(text);
};

const addBlindShippingNote = (text) => {
  if (isBlindShippingNotePresent(text)) return text;
  const trimmed = (text || "").trim();
  if (!trimmed) return BLIND_SHIPPING_DIRECTIVE;
  return `${BLIND_SHIPPING_DIRECTIVE}\n\n${trimmed}`;
};

const removeBlindShippingNote = (text) => {
  if (!text) return "";
  let cleaned = String(text)
    .replace(/\*+\s*BLIND SHIPPING ONLY\s*\*+[\s\S]*?(inside or outside the package\.?)/gi, "")
    .replace(/\*+\s*BLIND SHIPMENT DIRECTIVE:?[\s\S]*?(inside or outside the package\.?)/gi, "")
    .replace(/Please do NOT include any (?:pricing|pring) on invoices, receipts, price tags, or promotional materials inside or outside the package\.?/gi, "")
    .replace(/\*+\s*BLIND SHIPPING ONLY\s*\*+/gi, "")
    .trim();
  return cleaned;
};

const PurchaseOrderDetails = (props) => {
  const {
    state,
    vendor,
    obj,
    line_items,
    setLineItems,
    subTotal,
    total,
    poNumber,
    terms,
    setTerms,
    shipping,
    setShipping,
    company,
    setCompany,
    vendorInstructions,
    setVendorInstructions,
    orderNote,
    setOrderNote,
    totalTaxAmount,
    setTotalTaxAmount,
    shippingCheckboxes,
    setShippingCheckboxes,
    handleCreate,
    generatePdf,
    targetRef,
    shippingData,
    setShippingData,
    billingData,
    setBillingData,
    comingToTM,
    loader,
    checks, vendorPoNumber, setVendorPoNumber,
    purchaseOrderStatus, setPurchaseOrderStatus, directPO, itemModal,
    toggleItemModal, new_line_items, setNewLineItems,
    tm, setTm, pageLoader, dnhData, ingramData, distributorStockData, distributorStockLoading, freightBillingAccount, setFreightBillingAcc, usAddresses, selectedUSAddressId, setSelectedUSAddressId, soLineItems,
    addressType, setAddressType, signatureRequired, setSignatureRequired,
  } = useCreatePurchaseOrder(props);
  if (pageLoader) {
    return (
      <div className="mt-4">
        <OrderDetailsSkeleton />
      </div>
    )
  }
  return (
    <>
      <div className="mb-5">
        <PurchaseOrderDetailsHeader
          state={state}
          handleCreate={handleCreate}
          handleClick={generatePdf}
          poNumber={poNumber}
          loader={loader}
        />
        {itemModal &&
          <AddOrderItem
            toggle={toggleItemModal}
            modal={itemModal}
            setLineItems={setLineItems}
            line_items={line_items}
            new_line_items={new_line_items}
            setNewLineItems={setNewLineItems}
            soLineItems={soLineItems}
          />}
        <div ref={targetRef}>
          <PageName title={"Purchase Details"} />
          <Row className="mb-3">
            <Col md={3}>
              <OrderBillingAddressCard
                title="Vendor Info"
                data={vendor?.billing[0]}
                shippingCheckboxes={shippingCheckboxes}
                setShippingCheckboxes={setShippingCheckboxes}
                billingData={billingData}
                setBillingData={setBillingData}
              />
            </Col>
            <Col md={3}>
              <OrderShippingAddressCard
                title="Ship To"
                data={shippingData}
                shippingCheckboxes={shippingCheckboxes}
                setShippingCheckboxes={setShippingCheckboxes}
                shippingData={shippingData}
                setShippingData={setShippingData}
                comingToTM={comingToTM}
                checks={checks}
                tm={tm}
                setTm={setTm}
                usAddresses={usAddresses}
                selectedUSAddressId={selectedUSAddressId}
                setSelectedUSAddressId={setSelectedUSAddressId}
              />
            </Col>
            <Col md={3}>
              <PurchaseOrderInformations
                terms={terms}
                setTerms={setTerms}
                company={company}
                setCompany={setCompany}
                shipping={shipping}
                setShipping={setShipping}
                freightBillingAcc={freightBillingAccount}
                setFreightBillingAcc={setFreightBillingAcc}
              />
            </Col>
            <Col md={3}>
              <POBasicInformations
                vendor={vendor}
                poNumber={poNumber}
                created_at={obj?.created_at}
                vendorPoNumber={vendorPoNumber} setVendorPoNumber={setVendorPoNumber}
                purchaseOrderStatus={purchaseOrderStatus}
                setPurchaseOrderStatus={setPurchaseOrderStatus}
                orderData={obj}
                addressType={addressType}
                setAddressType={setAddressType}
                signatureRequired={signatureRequired}
                setSignatureRequired={setSignatureRequired}
              />
            </Col>
            <Row className="my-3" >
              <Col>
                <div className="d-flex justify-content-start align-items-center">
                  <h4>Items</h4>
                </div>
              </Col>
              {
                directPO &&
                <Col>
                  <div className="d-flex justify-content-end align-items-center">
                    <GeneralButton
                      title={"Add Item"}
                      className={"white-button rounded-0"}
                      handleClick={toggleItemModal}
                    />
                  </div>
                </Col>
              }
            </Row>
            {line_items?.length > 0 ? (
              line_items?.map((item, index) => {
                const soItem = soLineItems?.find((so) =>
                  (so?.sku && item?.sku && so.sku.toLowerCase() === item.sku.toLowerCase())
                );
                return (
                  <div className="item_body_wrapper" key={item?.sku || index}>
                    <PurchaseItemCard
                      key={item?.sku || index}
                      index={index}
                      data={item}
                      line_items={line_items}
                      setLineItems={setLineItems}
                      imgURL={item?.image?.src}
                      stockData={distributorStockData?.length > 0 ? distributorStockData : [...dnhData, ...ingramData]}
                      distributorStockLoading={distributorStockLoading}
                      maxSoQuantity={soItem ? parseInt(soItem.quantity) : undefined}
                    />
                  </div>
                );
              })
            ) : (
              <Card className="items__notfound rounded-0 mt-3 ">
                <p>No Items Found </p>
                <img src={notFound} className="notFoundImage" alt="" />
              </Card>
            )}
            <Row className="mb-4 d-flex align-items-stretch gy-4">
              <Col md={8}>
                <Card className="border-0 shadow-sm h-100">
                  <CardBody className="p-4 d-flex flex-column gap-4">
                    <div>
                      <div className="d-flex align-items-center gap-2 mb-2">
                        <div className="bg-primary-soft p-2 rounded-circle text-primary">
                          <FiFileText size={16} />
                        </div>
                        <h5 className="fw-bold text-dark mb-0 fs-15">Internal Note</h5>
                      </div>
                      <NotesCard
                        className="notesCard modern-notes border"
                        type="textarea"
                        height="80px"
                        placeholder="Add internal notes for this PO..."
                        value={orderNote}
                        handleChange={(e) => setOrderNote(e.target.value)}
                      />
                    </div>
                    <div>
                      <div className="d-flex justify-content-between align-items-center mb-2 flex-wrap gap-2">
                        <div className="d-flex align-items-center gap-2">
                          <div className="bg-primary-soft p-2 rounded-circle text-primary">
                            <FiFileText size={16} />
                          </div>
                          <h5 className="fw-bold text-dark mb-0 fs-15">Vendor Instructions</h5>
                        </div>
                        <div className="form-check form-switch mb-0 d-flex align-items-center gap-2">
                          <input
                            className="form-check-input pointer"
                            type="checkbox"
                            id="toggleBlindShipNoteCreatePO"
                            checked={isBlindShippingNotePresent(vendorInstructions)}
                            onChange={(e) => {
                              if (e.target.checked) {
                                setVendorInstructions(addBlindShippingNote(vendorInstructions));
                              } else {
                                setVendorInstructions(removeBlindShippingNote(vendorInstructions));
                              }
                            }}
                            style={{ width: "2.2em", height: "1.1em", cursor: "pointer" }}
                          />
                          <label
                            className="form-check-label mb-0 fw-semibold text-dark pointer"
                            htmlFor="toggleBlindShipNoteCreatePO"
                            style={{ fontSize: "13px", cursor: "pointer", userSelect: "none" }}
                          >
                            Include Blind Shipping Note
                          </label>
                        </div>
                      </div>
                      <NotesCard
                        className="notesCard modern-notes border"
                        type="textarea"
                        height="80px"
                        placeholder="Instructions for the vendor..."
                        value={vendorInstructions}
                        handleChange={(e) => setVendorInstructions(e.target.value)}
                      />
                    </div>
                  </CardBody>
                </Card>
              </Col>
              <Col md={4}>
                <div className="d-flex flex-column h-100">
                  <PurchaseTotalCard
                    height="100%"
                    totalTaxAmount={totalTaxAmount}
                    subTotal={subTotal}
                    total={total}
                    setTotalTaxAmount={setTotalTaxAmount}
                  />
                </div>
              </Col>
            </Row>

            <Row className="mx-2 mx-lg-0 ">
              <InternalNotesTable orderNote={orderNote} />
            </Row>
          </Row>

        </div>
      </div >
    </>

  );
};
export default PurchaseOrderDetails;
